import { render } from "./leftnav.vue?vue&type=template&id=67b238ee&scoped=true&bindings={\"clickNav\":\"data\",\"mouseNav\":\"data\",\"clickChildNav\":\"data\",\"mouseChildNav\":\"data\",\"childListCtrl\":\"data\",\"headImg1\":\"data\",\"headImg2\":\"data\",\"nav\":\"data\",\"navBtn\":\"options\",\"childnavBtn\":\"options\",\"nav2Btn\":\"options\"}"
import script from "./leftnav.vue?vue&type=script&lang=js"
export * from "./leftnav.vue?vue&type=script&lang=js"

import "./leftnav.vue?vue&type=style&index=0&id=67b238ee&lang=less&scoped=true"
script.render = render
script.__scopeId = "data-v-67b238ee"

export default script